module.exports = __webpack_public_path__ + "static/groshi-3820795881f860b58d31f6893996d6b3.png";